"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStorageMethods = getStorageMethods;
exports.isScheduledCacheCleanup = isScheduledCacheCleanup;
exports.removeScheduledCacheCleanup = removeScheduledCacheCleanup;
var _constants = require("../constants");
var _logger = require("../logger");
var _types = require("../types");
var _storageImplIndexedDb = require("./storageImplIndexedDb");
var _storageImplLocal = require("./storageImplLocal");
/** Storage methods "factory". Returns a set of methods for accessing the given type of storage. */
function getStorageMethods(storageType) {
  // TODO -- There could also be the fallback from IndexedDb to localStorage if the former wasn't available.
  // TODO -- The particular storage implementations could be lazy loaded, but the code is quite small.
  switch (storageType) {
    case _types.StorageType.IndexedDb:
      return {
        isStorageAvailable: _storageImplIndexedDb.isStorageAvailable,
        getStorageItem: _storageImplIndexedDb.getStorageItem,
        setStorageItem: _storageImplIndexedDb.setStorageItem,
        removeStorageItem: _storageImplIndexedDb.removeStorageItem
      };
    default:
      // localStorage
      return {
        isStorageAvailable: _storageImplLocal.isStorageAvailable,
        getStorageItem: _storageImplLocal.getStorageItem,
        setStorageItem: _storageImplLocal.setStorageItem,
        removeStorageItem: _storageImplLocal.removeStorageItem
      };
  }
}

/**
 * Checks for scheduled cache cleanup flag presence in storage.
 * This is small data and optionally being also set in legacy Online,
 * so always using localStorage in current implementation.
 */
function isScheduledCacheCleanup() {
  if (!(0, _storageImplLocal.isStorageAvailable)()) {
    return false;
  }
  const result = localStorage.getItem(_constants.SCHEDULED_CLEANUP_KEY);
  if (result) {
    (0, _logger.logDebug)('Cache cleanup was scheduled with last page reload.');
  }
  return result === null ? false : Boolean(result);
}

/** Removes scheduled cache cleanup flag from storage. */
function removeScheduledCacheCleanup() {
  if (!(0, _storageImplLocal.isStorageAvailable)()) {
    return false;
  }
  localStorage.removeItem(_constants.SCHEDULED_CLEANUP_KEY);
  return true;
}